import React, { useEffect, useState } from 'react';
import magasin from './assets/auplaisirgourmand.jpg';
import './StoreInfo.css';

export default function StoreInfo() {
  const [storeData, setStoreData] = useState(null);

  useEffect(() => {
    fetch('/api/store/info')
      .then(res => res.json())
      .then(data => setStoreData(data))
      .catch(err => console.error('Erreur chargement store info:', err));
  }, []);

  if (!storeData) {
    return <p>Chargement des informations du magasin...</p>;
  }

  return (
    <div className="store-info">
      <a href={storeData.adresseUrl} target="_blank" rel="noopener noreferrer">
        <img className='home-card' src={magasin} alt="Boutique Au Plaisir Gourmand" />
      </a>
      <p><strong>Mail :</strong> <a href={`mailto:${storeData.email}`}>{storeData.email}</a></p>
      <p><strong>Adresse :</strong> <a href={storeData.adresseUrl} target="_blank" rel="noopener noreferrer">{storeData.adresse}</a></p>
      <p><strong>Téléphone :</strong> {' '}
        {storeData.telephones.map((tel, index) => (
          <React.Fragment key={index}>
            <a href={`tel:${tel.replace(/ /g, '')}`}>{tel}</a>
            {index < storeData.telephones.length - 1 && ' / '}
          </React.Fragment>
        ))}
      </p>
      <p>
        <a href={storeData.adresseUrl} target="_blank" rel="noopener noreferrer">
          Voir sur Google Maps
        </a>
      </p>
      <p>
        Horaires :<br />
        {storeData.horaires.map((h, i) => (
          <span key={i}>{`- ${h}`}<br /></span>
        ))}
      </p>
    </div>
  );
}
